CustomerAccountUpdatePaymentController.$inject = ["API_URL", "$http", "$q", "$timeout", "$rootScope", "$filter"];
angular.module('calendarApp').controller('CustomerAccountUpdatePaymentController', CustomerAccountUpdatePaymentController);

function CustomerAccountUpdatePaymentController(API_URL, $http, $q, $timeout, $rootScope, $filter) {
  var update = this,
      throbber = $rootScope.throbber;
  update.updatePaymentMethod = true;
  update.invoiceToPay = null;
  if (!window.Stripe) return $rootScope.throbber.showError("Sorry but an error occurred: could not connect to Stripe. Please try re-loading the page. ");
}